module.exports = __webpack_public_path__ + "static/img/4.35bc023.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiankeng/4.jpg
// module id = 8zk7
// module chunks = 1